<template>
  <v-data-table
    ref="vDataTable"
    :headers="headers"
    :search="internalSearch"
    class="dataTable"
    :no-results-text="noResultsFound"
    :sort-by="sortBy"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <!-- Default slot for search input -->
    <template v-slot:top>
      <v-text-field
        v-model="internalSearch"
        prepend-inner-icon="mdi-magnify"
        :label="searchLabel"
        :aria-label="searchAriaLabel"
        class="py-4 px-8 searchInput"
        single-line
        hide-details
        v-on="$listeners"
        v-bind="$attrs"
      />
    </template>
    <!-- Default slot for table headers -->
    <template v-for="headerData in headers" :slot="`header.${headerData.value}`">
      <v-btn
        :key="headerData.value"
        class="headerBtn"
        text
        small
      >
        {{ headerData.text }}
      </v-btn>
    </template>
    <!--custom slots passed in to this component -->
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name"/>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'AdsDataTable',
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    searchLabel: {
      type: String,
      default: 'Search'
    },
    searchAriaLabel: {
      type: String,
      default: ''
    },
    sortBy: {
      type: String,
      default: () => ''
    },
    noResultsFound: {
      type: String,
      default: () => 'No results found.'
    },
    search: {
      type: String,
      default: ''
    }
  },
  watch: {
    search(newValue) {
      this.dataSearch = newValue
    }
  },
  data() {
    return {
      dataSearch: this.search
    }
  },
  computed: {
    internalSearch:  {
      get() { return this.dataSearch },
      set(value) {
        this.dataSearch = value
        this.$emit('update:search', value)
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables.scss';

::v-deep .v-text-field > .v-input__control > .v-input__slot:before,
::v-deep .v-text-field > .v-input__control > .v-input__slot:after {
  border-width: 0;
}

.searchInput {
  border-bottom: 1px solid $ads-light-20;
  color: $ads-dark-60;

  ::v-deep .v-label {
    color: $ads-dark-60;
    font-size: 16px;
    font-weight: 400;
  }

  ::v-deep .v-icon {
    color: $ads-dark-60;
  }
}

.headerBtn {
  margin: 0;
  border: none;
  padding: 0 !important;
  font-weight: inherit;
  color: inherit;

  &:hover {
    text-decoration: none;
  }

  &:hover::before {
    opacity: 0;
  }
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th > button,
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: $ads-navy;
  font-weight: 400;
  font-size: 16px;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead
> tr > th.sortable.active button {
  font-weight: bold;
}

.theme--light.dataTable.v-data-table::v-deep {
  .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row) {
    border-bottom: 0px;
  }
}

::v-deep .dataTable.v-data-table .v-data-footer {
  button {
    border: 0;
  }

  .v-btn.v-btn--icon {
    color: $ads-dark-70;
  }
}
::v-deep .v-data-footer {
  .v-data-footer__select .v-input.v-select {
    margin-left: 13px;
  }

  .v-data-footer__pagination {
    margin-right: 6px;
  }

  .v-data-footer__icons-before button.v-btn {
    margin-right: 3px;
  }

  .v-data-footer__icons-after button.v-btn {
    margin-left: 3px;
  }
}

.dataTable ::v-deep table {
  & td:not(.v-data-table__mobile-row),
  & thead:not(.v-data-table-header-mobile) th {
    &:first-child {
      padding-left: 32px;
    }

    &:last-child {
      padding-right: 32px;
    }
  }
}
</style>
